import { translateMessage } from "@/i18n";
export type ToastTone = "error" | "info" | "success";
export interface ToastMessage {
  id: string;
  message: string;
  tone?: ToastTone;
}
export interface ToastRegionProps {
  label?: string;
  messages: readonly ToastMessage[];
  onDismiss?: (id: string) => void;
}
const toneClasses: Record<ToastTone, string> = {
  error: "border-danger/30 bg-danger-subtle text-danger",
  info: "border-info/30 bg-info-subtle text-info",
  success: "border-positive/30 bg-positive-subtle text-positive",
};
export function ToastRegion({
  label = "Notifications",
  messages,
  onDismiss,
}: ToastRegionProps) {
  return (
    <div
      aria-label={label}
      aria-live="polite"
      aria-relevant="additions text"
      className="pointer-events-none fixed right-4 top-4 z-50 flex w-[min(24rem,calc(100vw-2rem))] flex-col gap-2"
      role="region"
    >
      {messages.map((message) => (
        <div
          className={`pointer-events-auto rounded-card border p-4 shadow-soft ${toneClasses[message.tone ?? "info"]}`}
          key={message.id}
        >
          <div className="flex items-start justify-between gap-4">
            <p className="text-sm font-medium">{message.message}</p>
            {onDismiss && (
              <button
                aria-label={translateMessage("common.ToastRegion.dismissNotification")}
                className="rounded px-1 font-bold focus:outline-none focus:ring-2 focus:ring-current"
                onClick={() => onDismiss(message.id)}
                type="button"
              >
                <span aria-hidden="true">×</span>
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
